import React, {useEffect} from 'react';
import {Select} from 'antd';
import useKnowledgeBank from '../../hooks/apis/useKnowledgeBank';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function KnowledgeBankSelect(props: {value?: number; onChange?: (value: number) => any}) {
  const listState = useKnowledgeBank.list();
  useEffect(() => {
    listState.request().catch(CommonApiErrorHandler);
  }, []);
  return (
    <Select size={'large'} placeholder={'请选择题库'} value={props.value} onChange={props.onChange}>
      {listState.data?.map(item => (
        <Select.Option value={item.id} key={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  );
}
